import { render, staticRenderFns } from "./IdeaFinish.vue?vue&type=template&id=296824f4"
import script from "./IdeaFinish.vue?vue&type=script&lang=js"
export * from "./IdeaFinish.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports